// src/components/ClarityTracker.jsx
import { useEffect } from "react";

const CLARITY_ID = "uis1d4h5de"; // your Clarity ID

const ClarityTracker = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    // avoid injecting script multiple times
    if (window.clarity || document.getElementById("ms-clarity")) return;

    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.id = "ms-clarity";
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_ID);
  }, []);

  return null; // nothing to render
};

export default ClarityTracker;
